import axios from 'axios';

export default class OffersClient {
  constructor(jwt) {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_OFFERS_API,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      timeout: 10000,
    });
  }

  async isDueForDisplay(location) {
    const url = '/history';
    let response;
    let error;
    try {
      response = await this.client.get(url, {
        params: { location },
      });
    } catch (err) {
      error = new Error(`\`isDueForDisplay\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data.dueToDisplay;
    }
    return null;
  }

  // async getAgreements(location, companyId = null, inspectionId = null) {
  async getAgreements(params) {
    const url = '';
    let response;
    let error;
    try {
      response = await this.client.get(url, {
        params,
      });
    } catch (err) {
      error = new Error(`\`getAgreements\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data;
    }
    return null;
  }

  async updateAgreements(payload) {
    const url = '';
    let response;
    let error;
    try {
      response = await this.client.put(url, payload);
    } catch (err) {
      error = new Error(`\`updateAgreements\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data;
    }
    return null;
  }
}
